<template>
  <div color="white">
    <v-row align="center">
      <v-col cols="4">
        <v-row>
          <span class="card-text-large" light>{{shipment.departure * 1000 | justTime($i18n.locale)}} - {{shipment.arrival * 1000 | justTime($i18n.locale)}}</span>
          <span class="font-weight-light">{{shipment.departure * 1000 | dateToReadableFull($i18n.locale)}}</span>
        </v-row>
      </v-col>

      <v-col cols="4">
        <v-row>
          <span class="card-text-large">{{shipment.vehicle.company}}</span>
          <span class="font-weight-light">{{shipment.vehicle.name}} &#9679; {{shipment.vehicle.plate_number}}</span>
        </v-row>
      </v-col>

      <v-col cols="2">
        <v-row>
          <span class="font-weight-light"><v-icon class="icon">fa fa-box</v-icon> {{shipment.volume}} m&sup3;</span>
          <span class="font-weight-light"><v-icon class="icon">fas fa-weight</v-icon> {{shipment.weight}} t</span>
        </v-row>
      </v-col>

      <v-col cols="2">
        <v-row>
          <v-row justify="end">
            <v-chip color="#50E898">{{shipment.label}}</v-chip>
            <v-chip color="#6A68CD">{{shipment.status}}</v-chip>
          </v-row>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>

export default {
  name: 'Card1PL',
  props: {
    shipment: Object
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.card-text-large {
  font-size: 17px;
}
.icon {
  font-size: 13px;
}
</style>
